import { useMemo } from 'react';
import { useAdditionalBundleStockLevels, useBundledProducts } from '../useCustomerCatalogueService';
import { StockBinLevel, useDefaultBundleStockLevels } from './useDefaultBundleStockLevels';

export const useBundleStockLevels = () => {
  const bundledProducts = useBundledProducts();
  const additionalStockLevels = useAdditionalBundleStockLevels();
  const defaultLevels = useDefaultBundleStockLevels();

  return useMemo(() => {
    const stockLevels: StockBinLevel[] = bundledProducts.map(product => {
      const additionalStock = additionalStockLevels.find(a => a.productId === product.id);
      const defaultLevel = defaultLevels.find(d => d.product.id === product.id);

      return {
        product,
        maxStockLevel:
          additionalStock !== undefined ? additionalStock.maximumStockLevel : defaultLevel?.maxStockLevel || 0,
        minStockLevel:
          additionalStock !== undefined ? additionalStock.minimumStockLevel : defaultLevel?.minStockLevel || 0,
        recMaxStockLevel: defaultLevel?.recMaxStockLevel,
        recMinStockLevel: defaultLevel?.recMinStockLevel
      };
    });

    return stockLevels;
  }, [bundledProducts, additionalStockLevels]);
};
